export default "__VITE_ASSET__1c2a1caa__"